var map = {
	"./app.js": 2056,
	"./auxiliary.js": 9475,
	"./digitalBook.js": 19470,
	"./offline.js": 53532,
	"./paperCollect.js": 54875,
	"./params.js": 32441,
	"./pictureBook.js": 84900,
	"./pk.js": 25418,
	"./popQuizCollect.js": 11547,
	"./router.js": 6190,
	"./sentence.js": 86494,
	"./special.js": 43720,
	"./text.js": 29052,
	"./unit.js": 48081,
	"./user.js": 12296,
	"./window.js": 14971,
	"./word.js": 64455,
	"./wordDictation.js": 52422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84870;